var chunkMapping = {
	"webpack_container_remote_base_hooks": [
		"webpack/container/remote/base/hooks"
	],
	"webpack_container_remote_base_classes": [
		"webpack/container/remote/base/classes"
	],
	"webpack_container_remote_base_themes": [
		"webpack/container/remote/base/themes"
	],
	"webpack_container_remote_base_constants": [
		"webpack/container/remote/base/constants"
	],
	"webpack_container_remote_base_utils": [
		"webpack/container/remote/base/utils"
	],
	"webpack_container_remote_base_i18n": [
		"webpack/container/remote/base/i18n"
	],
	"webpack_container_remote_base_stores": [
		"webpack/container/remote/base/stores"
	],
	"common_src_components_primitives_fileicon_CSV_svg-common_src_components_primitives_fileicon_D-95c1bc": [
		"webpack/container/remote/base/services"
	],
	"common_src_components_primitives_richtext_formats_bold_js-common_src_components_primitives_ri-08a114": [
		"webpack/container/remote/base/form",
		"webpack/container/remote/base/chartthemeutil"
	],
	"node_modules_pnpm_ant-design_icons_4_7_0_react-dom_18_2_0_react_18_2_0_node_modules_ant-desig-5b1ea6": [
		"webpack/container/remote/base/form"
	],
	"webpack_container_remote_kfplatform_filePreview": [
		"webpack/container/remote/kfplatform/filePreview"
	],
	"webpack_container_remote_kfplatform_filePicker": [
		"webpack/container/remote/kfplatform/filePicker"
	]
};
var idToExternalAndNameMapping = {
	"webpack/container/remote/base/hooks": [
		"default",
		"./hooks",
		"webpack/container/reference/base"
	],
	"webpack/container/remote/base/classes": [
		"default",
		"./classes",
		"webpack/container/reference/base"
	],
	"webpack/container/remote/base/themes": [
		"default",
		"./themes",
		"webpack/container/reference/base"
	],
	"webpack/container/remote/base/constants": [
		"default",
		"./constants",
		"webpack/container/reference/base"
	],
	"webpack/container/remote/base/utils": [
		"default",
		"./utils",
		"webpack/container/reference/base"
	],
	"webpack/container/remote/base/i18n": [
		"default",
		"./i18n",
		"webpack/container/reference/base"
	],
	"webpack/container/remote/base/stores": [
		"default",
		"./stores",
		"webpack/container/reference/base"
	],
	"webpack/container/remote/base/services": [
		"default",
		"./services",
		"webpack/container/reference/base"
	],
	"webpack/container/remote/base/form": [
		"default",
		"./form",
		"webpack/container/reference/base"
	],
	"webpack/container/remote/base/chartthemeutil": [
		"default",
		"./chartthemeutil",
		"webpack/container/reference/base"
	],
	"webpack/container/remote/kfplatform/filePreview": [
		"default",
		"./filePreview",
		"webpack/container/reference/kfplatform"
	],
	"webpack/container/remote/kfplatform/filePicker": [
		"default",
		"./filePicker",
		"webpack/container/reference/kfplatform"
	]
};
__webpack_require__.f.remotes = function(chunkId, promises) {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach(function(id) {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = function(error) {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = function() {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = function(fn, arg1, arg2, d, next, first) {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then(function(result) { return next(result, d); }, onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = function(external, _, first) { return external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError(); };
			var onInitialized = function(_, external, first) { return handleFunction(external.get, data[1], getScope, 0, onFactory, first); };
			var onFactory = function(factory) {
				data.p = 1;
				__webpack_require__.m[id] = function(module) {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}